import React from 'react';
import { Link } from 'react-router-dom';

export function Header() {
  return (
    <header className="bg-gradient-to-r from-pink-500 to-orange-500 text-white shadow-lg">
      <div className="max-w-6xl mx-auto px-4 py-6">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-3xl">🎪</span>
            <h1 className="text-2xl font-bold">Alpharetta Kids Events</h1>
          </Link>
          <nav className="flex gap-6">
            <Link to="/" className="hover:text-pink-100 transition">
              Home
            </Link>
            <Link to="/calendar" className="hover:text-pink-100 transition">
              Calendar
            </Link>
            <Link to="/submit" className="hover:text-pink-100 transition">
              Submit
            </Link>
            <Link to="/about" className="hover:text-pink-100 transition">
              About
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
